import { Customer } from '@clients/customersClient';

type CustomerName = Partial<
    Pick<Customer, 'nickname' | 'social_name' | 'name' | 'printed_name'>
>;

const getCustomerName = (customer?: CustomerName) => {
    return (
        customer?.nickname ||
        customer?.social_name ||
        customer?.name ||
        customer?.printed_name ||
        ''
    );
};

export default getCustomerName;
